import React from 'react'
import { SearchBoxProps } from '@/components/organisms/IntegrationsGrid/types'

export function SearchBox({ searchQuery, handleSearch, search_input_placeholder, handleClearSearch }: SearchBoxProps) {
  return (
    <div className="relative">
      <i className="absolute fa fa-search left-16 netbook:left-24 top-1/2 -translate-y-1/2" aria-hidden="true" />
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearch}
        className="w-full border-1 border-gray pl-48 netbook:pl-56 pr-24 py-14 rounded-[5px] placeholder:text-bodyM netbook:placeholder:text-bodyL placeholder:text-[#ABABAB] focus-within:border-primary-500 transition"
        placeholder={search_input_placeholder}
        id="integration-search"
      />
      {searchQuery.length > 0 && (
        <button aria-label="reset search" type="button" className="resetIcon" onClick={handleClearSearch}>
          <i className=" absolute fa fa-times p-12 right-12 top-1/2 -translate-y-1/2" aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
